import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, forwardRef } from 'react';
import View from '../view';
import Image from '../image';
import { isNode } from 'universal-env';
import { devicePixelRatio } from 'universal-device';
import optimizer from './optimizer/index';
import { isSupport } from './webp';
import rpx2vw from './rpx2vw';
var isSupportJPG = false;
var isSupportPNG = false;
if (!isNode) {
  isSupport(function (_isSupportJPG) {
    isSupportJPG = _isSupportJPG;
  });
  isSupport(function (_isSupportPNG) {
    isSupportPNG = _isSupportPNG;
  }, 'alpha');
}
function parseSuffix(suffix) {
  var result = [];
  var ret = [];
  if (typeof suffix === 'string') {
    ret = suffix.split(',');
  }
  if (Array.isArray(suffix)) {
    ret = suffix;
  }
  if (ret && ret[0]) {
    result[0] = ret[0];
  }
  if (ret && ret[1]) {
    result[1] = ret[1];
  }
  return result;
}
function getQualitySuffix(highQuality, suffix) {
  var _suffix = parseSuffix(suffix);
  return highQuality ? _suffix[0] : _suffix[1];
}
var Picture = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    resizeMode = props.resizeMode,
    width = props.width,
    height = props.height,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==' : _props$placeholder,
    _props$source = props.source,
    source = _props$source === void 0 ? {
      uri: ''
    } : _props$source,
    _props$autoRemoveSche = props.autoRemoveScheme,
    autoRemoveScheme = _props$autoRemoveSche === void 0 ? true : _props$autoRemoveSche,
    _props$autoReplaceDom = props.autoReplaceDomain,
    autoReplaceDomain = _props$autoReplaceDom === void 0 ? true : _props$autoReplaceDom,
    _props$autoScaling = props.autoScaling,
    autoScaling = _props$autoScaling === void 0 ? true : _props$autoScaling,
    _props$autoWebp = props.autoWebp,
    autoWebp = _props$autoWebp === void 0 ? true : _props$autoWebp,
    _props$ignoreGif = props.ignoreGif,
    ignoreGif = _props$ignoreGif === void 0 ? true : _props$ignoreGif,
    _props$autoCompress = props.autoCompress,
    autoCompress = _props$autoCompress === void 0 ? true : _props$autoCompress,
    _props$highQuality = props.highQuality,
    highQuality = _props$highQuality === void 0 ? true : _props$highQuality,
    _props$compressSuffix = props.compressSuffix,
    compressSuffix = _props$compressSuffix === void 0 ? ['Q75', 'Q50'] : _props$compressSuffix,
    _props$defaultHeight = props.defaultHeight,
    defaultHeight = _props$defaultHeight === void 0 ? '100vw' : _props$defaultHeight,
    _props$lazyload = props.lazyload,
    lazyload = _props$lazyload === void 0 ? false : _props$lazyload,
    _props$autoPixelRatio = props.autoPixelRatio,
    autoPixelRatio = _props$autoPixelRatio === void 0 ? true : _props$autoPixelRatio;
  var uri = source.uri;
  var nativeProps = Object.assign({}, props);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var sWidth = style.width,
    sHeight = style.height;
  if (!sHeight && sWidth && width && height) {
    var pScaling = width / (typeof sWidth === 'string' ? parseInt(sWidth, 10) : sWidth);
    sHeight = parseInt(height / pScaling + '', 10);
  }
  var newStyle = Object.assign({
    height: sHeight
  }, style);
  if (uri) {
    if (!isNode && autoPixelRatio && devicePixelRatio > 1) {
      if (typeof sWidth === 'string' && sWidth.indexOf('rpx') > -1) {
        sWidth = rpx2vw(parseInt(sWidth.split('rpx')[0]) * 2 + 'rpx');
      }
    }
    uri = optimizer(uri, {
      ignoreGif: ignoreGif,
      ignorePng: true,
      removeScheme: autoRemoveScheme,
      replaceDomain: autoReplaceDomain,
      scalingWidth: autoScaling ? sWidth : 0,
      webp: autoWebp && isSupportJPG && isSupportPNG,
      compressSuffix: autoCompress ? getQualitySuffix(highQuality, compressSuffix) : ''
    });
  }
  if (resizeMode) {
    newStyle.resizeMode = resizeMode;
  }
  var url = placeholder;
  if (lazyload) {
    nativeProps.onAppear = function () {
      return setVisible(true);
    };
    if (visible) {
      url = uri;
    }
  } else {
    url = uri;
  }
  if (children) {
    return /*#__PURE__*/React.createElement(View, Object.assign({}, nativeProps, {
      className: className,
      style: Object.assign(Object.assign({}, newStyle), {
        backgroundImage: 'url(' + url + ')',
        backgroundSize: resizeMode || 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: resizeMode === 'cover' || resizeMode === 'contain' ? 'center' : null,
        height: newStyle.height ? newStyle.height : defaultHeight
      }),
      "data-once": true
    }), children);
  } else {
    return /*#__PURE__*/React.createElement(Image, Object.assign({}, nativeProps, {
      ref: ref,
      className: className,
      style: newStyle,
      "data-once": true,
      source: {
        uri: url
      }
    }));
  }
});
Picture.displayName = 'Picture';
export default Picture;